// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ocesO","header":"styles_header__4CeI3","footer":"styles_footer__E0txr","form":"styles_form__9ncE-","choose_all":"styles_choose_all__WovSN"};